import { useState } from 'react';
import { track } from '../lib/analytics';

export default function Header() {
  const [navOpen, setNavOpen] = useState(false);

  const onNavClick = (label: string) => {
    setNavOpen(false);
    track('nav_click', {
      element_label: label,
      element_location: 'header',
      section_name: 'header',
    });
  };

  return (
    <header className="gt-header">
      <a
        href="#hero"
        style={{ position: 'absolute', left: '-9999px', top: 0, zIndex: 100, background: '#201F1D', color: '#FAF9F7', fontWeight: 600, fontSize: 14, padding: '12px 20px', borderRadius: '0 0 6px 0', textDecoration: 'none' }}
        onFocus={e => { (e.target as HTMLElement).style.left = '0'; }}
        onBlur={e => { (e.target as HTMLElement).style.left = '-9999px'; }}
      >
        Skip to main content
      </a>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <svg viewBox="0 0 96 96" width={58} height={58} role="img" aria-label="GrihaTEK logo: a line-drawn house with animated signal arcs rising inside it" style={{ flex: 'none', display: 'block' }}>
          <path d="M10 46 L48 10 L86 46" fill="none" stroke="#201F1D" strokeWidth={5} strokeLinecap="round" strokeLinejoin="round" />
          <path d="M18 40 L18 86 L78 86 L78 40" fill="none" stroke="#201F1D" strokeWidth={5} strokeLinecap="round" strokeLinejoin="round" />
          <circle cx={48} cy={66} r={4.5} fill="#B68235" />
          <path d="M40.93 58.93 A10 10 0 0 1 55.07 58.93" style={{ animation: 'gt-arc 2.4s ease-in-out 0s infinite' }} fill="none" stroke="#B68235" strokeWidth={4.5} strokeLinecap="round" />
          <path d="M35.98 53.98 A17 17 0 0 1 60.02 53.98" style={{ animation: 'gt-arc 2.4s ease-in-out .25s infinite' }} fill="none" stroke="#B68235" strokeWidth={4.5} strokeLinecap="round" />
          <path d="M31.03 49.03 A24 24 0 0 1 64.97 49.03" style={{ animation: 'gt-arc 2.4s ease-in-out .5s infinite' }} fill="none" stroke="#B68235" strokeWidth={4.5} strokeLinecap="round" />
        </svg>
        <div>
          <div style={{ fontSize: 26, fontWeight: 600, letterSpacing: '-0.015em', lineHeight: 1, color: '#201F1D' }}>Griha<span style={{ color: '#B68235' }}>TEK</span></div>
          <h1 style={{ margin: '4px 0 0', fontSize: 13.5, fontWeight: 500, fontStyle: 'italic', color: '#55524C', letterSpacing: '0.02em' }}>Intelligence, indoors.<span style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap' }}> GrihaTEK — smart home automation in Kolkata and West Bengal.</span></h1>
        </div>
      </div>
      <button
        className="gt-hamburger"
        type="button"
        onClick={() => setNavOpen(o => !o)}
        aria-label={navOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={navOpen}
        aria-controls="gt-main-nav"
      >
        {navOpen ? '✕' : '☰'}
      </button>
      <nav id="gt-main-nav" aria-label="Sections" className={`gt-nav${navOpen ? ' gt-nav--open' : ''}`}>
        <a href="#rooms" onClick={() => onNavClick('Room by room')} style={{ fontSize: 14, fontWeight: 500, color: '#201F1D', textDecoration: 'none' }}>Room by room</a>
        <a href="#roomguardian" onClick={() => onNavClick('Our hardware')} style={{ fontSize: 14, fontWeight: 500, color: '#201F1D', textDecoration: 'none' }}>Our hardware</a>
        <a href="#builders" onClick={() => onNavClick('For builders')} style={{ fontSize: 14, fontWeight: 500, color: '#201F1D', textDecoration: 'none' }}>For builders</a>
        <a href="/guides" onClick={() => onNavClick('Guides')} style={{ fontSize: 14, fontWeight: 500, color: '#201F1D', textDecoration: 'none' }}>Guides</a>
        <a href="#assistant" onClick={() => onNavClick('Ask the assistant')} style={{ fontSize: 14, fontWeight: 600, color: '#7E5920', textDecoration: 'none', border: '1px solid #B68235', borderRadius: 999, padding: '7px 14px' }}>Ask the assistant</a>
      </nav>
    </header>
  );
}
